import { handleNetworkResponseAndGetJsonAsync, Network } from './Network'
import { GlobalVars } from '../../global'
import { AuthenticateUserResponse } from './collections/user/authenticateUser/authenticateUser_200'
import { AuthenticateUserRequest } from './collections/user/authenticateUser/authenticateUser_post'
import { UpdatePasswordResponse } from './collections/user/updatePassword/updatePassword_200'
import { UpdatePasswordRequest } from './collections/user/updatePassword/updatePassword_post'
import { UserDto, UserRole } from './sharedTypes/User'
import { AuthenticateResponse } from './sharedTypes/Auth'

export class UserManager {
    static _instance: UserManager | null = null

    static getManager(): UserManager {
        if (this._instance === null) {
            this._instance = new UserManager()
        }
        return this._instance
    }

    async authenticateAsync(username: string, password: string): Promise<AuthenticateUserResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/authenticate`
        const body: AuthenticateUserRequest = { username: username, password: password }
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: AuthenticateUserResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async updatePasswordAsync(oldPassword: string, newPassword: string): Promise<UpdatePasswordResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/password/update`
        const body: UpdatePasswordRequest = { oldPassword: oldPassword, newPassword: newPassword }
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: UpdatePasswordResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async createUserAsync(username: string, password: string, role: UserRole): Promise<AuthenticateResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/create`
        const body: { username: string; password: string; role: UserRole } = {
            username: username,
            password: password,
            role: role,
        }
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: AuthenticateResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async getUserAsync(id: string): Promise<AuthenticateResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: AuthenticateResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async deleteUserAsync(id: string): Promise<void> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            await handleNetworkResponseAndGetJsonAsync(response)
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async updateUserAsync(id: string, role: UserRole): Promise<UserDto> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user/${id}/update`
        const body: { role: UserRole } = { role: role }
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: UserDto = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
    async getUsersAsync(): Promise<{ users: UserDto[] }> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/user`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: { users: UserDto[] } = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
}
